// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/login-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.loginPage_old-container__OA0aU {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.loginPage_old-container__OA0aU.loginPage_wrap__\\+lXGx {
  flex-wrap: wrap;
}
.loginPage_old-container__OA0aU .loginPage_box__WB5YK.loginPage_col__DWz\\+8 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.loginPage_old-container__OA0aU .loginPage_box__WB5YK.loginPage_col__DWz\\+8 > div {
  width: 100%;
}
.loginPage_old-container__OA0aU .loginPage_box__WB5YK.loginPage_row__l8c8C {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.loginPage_old-container__OA0aU form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.loginPage_old-container__OA0aU form > .loginPage_box__WB5YK.loginPage_col__DWz\\+8 {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .loginPage_old-container__OA0aU form > .loginPage_box__WB5YK.loginPage_col__DWz\\+8 {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .loginPage_old-container__OA0aU, .loginPage_col__DWz\\+8, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .loginPage_old-container__OA0aU, .loginPage_col__DWz\\+8, form {
    padding: 0px;
  }
}
.loginPage_text-overflow-hidden__dcRk8 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loginPage_icon__Et9Ho {
  color: var(--accent-color);
}

.loginPage_richtext-output-wrap__DSprN .loginPage_se-video-container__ikEht figure {
  padding-bottom: 0 !important;
}

.loginPage_content__tgzEY {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 150px;
  width: 100%;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 430px;
  height: 850px;
  background: linear-gradient(180deg, #252525 0%, #1F1F1F 100%);
  box-shadow: 0px 20px 14px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  margin-bottom: 120px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_logo__vwHAU {
  width: 160px;
  height: 160px;
  margin-top: -110px;
  margin-right: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  filter: drop-shadow(0px 30px 10px rgba(0, 0, 0, 0.15));
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_signIn__70Dad {
  font-weight: 600;
  font-size: 22px;
  line-height: 185%;
  margin: 20px 0px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_logIn__QWdgi {
  font-weight: 500;
  font-size: 18px;
  line-height: 170%;
  margin-top: 15px;
  margin-bottom: 10px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_info__NH3Jx {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 340px;
  height: 290px;
  background: #1F1F1F;
  border-radius: 10px;
  padding: 25px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_info__NH3Jx .loginPage_infoWallet__maT7m {
  margin-top: 10px;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  color: rgba(255, 255, 255, 0.3);
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_info__NH3Jx img {
  margin-top: 25px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_loginForm__Io1CO {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: normal;
  height: 280px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_loginForm__Io1CO fieldset {
  border-color: rgba(255, 255, 255, 0.3);
  border-radius: 12px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_loginForm__Io1CO .loginPage_loginBtn__7iTFO {
  width: 340px;
  height: 60px;
  background: var(--accent-color);
  box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_loginForm__Io1CO .loginPage_loginBtn__7iTFO span {
  font-weight: 700;
  font-size: 18px;
  line-height: 130%;
  text-align: center;
  text-transform: uppercase;
  color: var(--accent-text-color);
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_links__vdGmz {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: normal;
  width: 100%;
  margin-bottom: 10px;
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_links__vdGmz p {
  margin: 5px 0px;
  color: rgba(255, 255, 255, 0.3);
}
.loginPage_content__tgzEY .loginPage_main__oyMYX .loginPage_block__aIEfX .loginPage_loginInfo__BfvUF .loginPage_links__vdGmz a {
  color: #FFFFFF !important;
}

.loginPage_otpBlock__fqM9N {
  height: 360px !important;
}

.loginPage_otpInfo__s7N89 {
  padding: 0px 30px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/pages/LoginPage/loginPage.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EDAE,aAAA;EACA,mBAAA;EACA,uBCDa;EDEb,mBCFqB;EACnB,iBAAA;EACA,WAAA;AA+EJ;AA9EI;EDJF,aAAA;EACA,mBCIY;EDHZ,uBCGiB;EDFjB,mBCEyB;EACnB,WAAA;EACA,YAAA;AAmFR;AAlFQ;EDRN,aAAA;EACA,sBCQgB;EDPhB,2BCOwB;EDNxB,mBCMoC;EAC1B,YAAA;EACA,aAAA;EACA,6DAAA;EACA,6CAAA;EACA,mBAAA;EACA,oBAAA;AAuFZ;AAtFY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,6DAAA;EACA,sDAAA;AAwFhB;AAvFY;EDvBV,aAAA;EACA,sBCuBoB;EDtBpB,uBCsB4B;EDrB5B,mBCqBoC;AA4FtC;AA3FgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA6FpB;AA5FgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA8FpB;AA7FgB;EDpCd,aAAA;EACA,sBCoCwB;EDnCxB,2BCmCgC;EDlChC,mBCkC4C;EAC1B,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAkGpB;AAjGoB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;AAmGxB;AAlGoB;EACI,gBAAA;AAoGxB;AAnGgB;EDnDd,aAAA;EACA,sBCmDwB;EDlDxB,6BCkDgC;EDjDhC,mBCiD8C;EAC5B,aAAA;AAwGpB;AAvGoB;EACI,sCAAA;EACA,mBAAA;AAyGxB;AAxGoB;EACI,YAAA;EACA,YAAA;EACA,+BD5Cf;EC6Ce,0CAAA;EACA,mBAAA;AA0GxB;AAzGwB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BDpDd;AC+Jd;AA1GgB;EDtEd,aAAA;EACA,sBCsEwB;EDrExB,uBCqEgC;EDpEhC,mBCoEwC;EACtB,WAAA;EACA,mBAAA;AA+GpB;AA9GoB;EACI,eAAA;EACA,+BAAA;AAgHxB;AA/GoB;EACI,yBAAA;AAiHxB;;AA/GA;EACI,wBAAA;AAkHJ;;AAjHA;EACI,iBAAA;EACA,kBAAA;AAoHJ","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../sass/settings'\n\n.content\n    +flex(row, center, center)\n    margin-top: 150px\n    width: 100%\n    .main\n        +flex(row, center, center)\n        width: 100%\n        height: 100%\n        .block\n            +flex(column, flex-start, center)\n            width: 430px\n            height: 850px\n            background: linear-gradient(180deg, #252525 0%, #1F1F1F 100%)\n            box-shadow: 0px 20px 14px rgba(0, 0, 0, 0.15)\n            border-radius: 12px\n            margin-bottom: 120px\n            .logo\n                width: 160px\n                height: 160px\n                margin-top: -110px\n                margin-right: 20px\n                background: url(\"../../assets/img/login-logo.png\") no-repeat\n                filter: drop-shadow(0px 30px 10px rgba(0, 0, 0, 0.15))\n            .loginInfo\n                +flex(column, center, center)\n                .signIn\n                    font-weight: 600\n                    font-size: 22px\n                    line-height: 185%\n                    margin: 20px 0px\n                .logIn\n                    font-weight: 500\n                    font-size: 18px\n                    line-height: 170%\n                    margin-top: 15px\n                    margin-bottom: 10px\n                .info\n                    +flex(column, flex-start, center)\n                    width: 340px\n                    height: 290px\n                    background: #1F1F1F\n                    border-radius: 10px\n                    padding: 25px\n                    .infoWallet\n                        margin-top: 10px\n                        font-size: 16px\n                        line-height: 130%\n                        text-align: center\n                        color: rgba(255, 255, 255, 0.3)\n                    img\n                        margin-top: 25px\n                .loginForm\n                    +flex(column, space-evenly, normal)\n                    height: 280px\n                    fieldset\n                        border-color: rgba(255, 255, 255, 0.3)\n                        border-radius: 12px\n                    .loginBtn\n                        width: 340px\n                        height: 60px\n                        background: $accent\n                        box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.2)\n                        border-radius: 10px\n                        span\n                            font-weight: 700\n                            font-size: 18px\n                            line-height: 130%\n                            text-align: center\n                            text-transform: uppercase\n                            color: $accent_text\n                .links\n                    +flex(column, center, normal)\n                    width: 100%\n                    margin-bottom: 10px\n                    p\n                        margin: 5px 0px\n                        color: rgba(255, 255, 255, 0.3)\n                    a\n                        color: #FFFFFF !important\n\n.otpBlock \n    height: 360px !important\n.otpInfo\n    padding: 0px 30px\n    text-align: center"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `loginPage_old-container__OA0aU`,
	"wrap": `loginPage_wrap__+lXGx`,
	"box": `loginPage_box__WB5YK`,
	"col": `loginPage_col__DWz+8`,
	"row": `loginPage_row__l8c8C`,
	"text-overflow-hidden": `loginPage_text-overflow-hidden__dcRk8`,
	"icon": `loginPage_icon__Et9Ho`,
	"richtext-output-wrap": `loginPage_richtext-output-wrap__DSprN`,
	"se-video-container": `loginPage_se-video-container__ikEht`,
	"content": `loginPage_content__tgzEY`,
	"main": `loginPage_main__oyMYX`,
	"block": `loginPage_block__aIEfX`,
	"logo": `loginPage_logo__vwHAU`,
	"loginInfo": `loginPage_loginInfo__BfvUF`,
	"signIn": `loginPage_signIn__70Dad`,
	"logIn": `loginPage_logIn__QWdgi`,
	"info": `loginPage_info__NH3Jx`,
	"infoWallet": `loginPage_infoWallet__maT7m`,
	"loginForm": `loginPage_loginForm__Io1CO`,
	"loginBtn": `loginPage_loginBtn__7iTFO`,
	"links": `loginPage_links__vdGmz`,
	"otpBlock": `loginPage_otpBlock__fqM9N`,
	"otpInfo": `loginPage_otpInfo__s7N89`
};
export default ___CSS_LOADER_EXPORT___;
